import { render } from "./WorkflowMenu.vue?vue&type=template&id=06454ee1"
import script from "./WorkflowMenu.vue?vue&type=script&lang=ts"
export * from "./WorkflowMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script